import React from "react";
import parse from 'html-react-parser';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography'

const CustomHeader = (props) => {
    const image = props.image;
    const uiConfig = props.uiConfig;

    return (
        <>
            <Container
                maxWidth={false}
                sx={{
                    width: '100%',
                    height: {xs: '67px', md: '88px'},
                    backgroundColor: uiConfig.backgroundColor ? uiConfig.backgroundColor : 'palette.background',
                    padding: {xs: '0 .25rem', md: '0 1rem'},
                    display: 'flex',
                    flexDirection: 'row'
                }}
            >
                <Box component='img' src={ window.URL.createObjectURL(image) } alt="Organization logo" sx={{height: {xs: '61px', md: '82px'}, margin: '3px .5rem'}}/>
                <Stack spacing={-.2} sx={{margin: {xs: '3px .5rem', md: '3px 1rem'}}}>
                    <Typography
                        sx={{
                            color: uiConfig.textColor ? uiConfig.textColor : 'sienna',
                            fontSize: {xs: '1.2rem', md: '1.5rem'},
                            margin: '0'
                        }}
                    >
                        {uiConfig?.headerText1 ? parse(uiConfig.headerText1) : ''}
                    </Typography>
                    { uiConfig.headerText2 &&
                        <Typography
                            sx={{
                                color: uiConfig.textColor ? uiConfig.textColor : 'sienna',
                                fontSize: {xs: '.8rem', md: '1.2rem'},
                                margin: '0',
                                lineHeight: {xs: '1.1rem', md: '1.4rem'},
                            }}
                        >
                            {uiConfig?.headerText2 ? parse(uiConfig.headerText2) : ''}
                        </Typography>
                    }
                    { uiConfig.location &&
                        <Typography
                            sx={{
                                color: uiConfig.textColor ? uiConfig.textColor : 'sienna',
                                fontSize: {xs: '.7rem', md: '1rem'},
                                margin: '0',
                                lineHeight: {xs: '1.1rem', md: '1.4rem'},
                            }}
                        >
                            {uiConfig?.location ? parse(uiConfig.location) : ''}
                        </Typography>
                    }
                </Stack>
            </Container>
        </>
    );
}

export default CustomHeader;
